import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent  implements OnInit {
  closebtn: any='flex';
  displaydata:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any){}
 ngOnInit(): void {
  this.displaydata=this.data.data
 }
}